import script from "./HeroLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroLanding.vue?vue&type=script&setup=true&lang=js"

import "./HeroLanding.vue?vue&type=style&index=0&id=ed7e03a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed7e03a0"]])

export default __exports__